// Contract Analysis Service
import { apiService } from './api';
import { API_ENDPOINTS } from '../constants/api';
import { ContractTerm, TermInstance, RiskAnalysis } from '../types';

export class ContractService {
  async getContractTerms(): Promise<ContractTerm[]> {
    return apiService.get<ContractTerm[]>(API_ENDPOINTS.CONTRACT_TERMS);
  }

  async getTermInstances(documentId: string): Promise<TermInstance[]> {
    return apiService.get<TermInstance[]>(
      `${API_ENDPOINTS.TERM_INSTANCES}?document_id=${documentId}`
    );
  }

  async getRiskAnalyses(documentId: string): Promise<RiskAnalysis[]> {
    return apiService.get<RiskAnalysis[]>(
      `${API_ENDPOINTS.RISK_ANALYSES}?document_id=${documentId}`
    );
  }

  async analyzeDocument(documentId: string): Promise<any> {
    return apiService.post(`${API_ENDPOINTS.ANALYZE_DOCUMENT}/${documentId}`);
  }

  async getDocumentSummary(documentId: string): Promise<any> {
    return apiService.get(`${API_ENDPOINTS.DOCUMENT_SUMMARY}/${documentId}`);
  }
}

export const contractService = new ContractService();